module.exports = __webpack_public_path__ + "static/img/tu9.ac615192.png";